import { Pagination } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './pagination.component.hbs';

export class PaginationComponent extends BaseComponent<Pagination> {
    protected override bindEvent = 'hawksearch:bind-pagination';
    protected override customTemplatePropertyName = 'pagination';
    protected override defaultHtml = defaultHtml;

    private defaultMaxPageLinks = 9;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || this.data.totalResults == 0) {
            return '';
        }

        const firstRecord = (this.data.page - 1) * this.data.pageSize + 1;
        let lastRecord = firstRecord + this.data.pageSize - 1;

        if (lastRecord > this.data.totalResults) {
            lastRecord = this.data.totalResults;
        }

        const html = template({
            page: this.data.page,
            pages: this.getPages(),
            firstPage: 1,
            lastPage: this.data.totalPages,
            firstRecord: firstRecord,
            lastRecord: lastRecord,
            totalRecords: this.data.totalResults ?? 0,
            totalPages: this.data.totalPages ?? 1,
            maxPageLinks: this.data.maxPageLinks ?? this.defaultMaxPageLinks,
            displayFirstLink: this.data.displayFirstLink && this.data.page > 1,
            displayPreviousLink: this.data.page > 1,
            displayNextLink: this.data.page < this.data.totalPages,
            displayLastLink: this.data.displayLastLink && this.data.page < this.data.totalPages,
            summary: `Showing ${firstRecord}-${lastRecord} of ${this.data.totalResults}`
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-page]').forEach((e) => {
            const value = e.getAttribute('hawksearch-page');

            if (value) {
                const page = parseInt(value);

                e.addEventListener('click', () => this.setPage(page));
            }
        });
    }

    protected async setPage(page: number): Promise<void> {
        await searchService.paginate(page);
    }

    private getPages(): Array<number> {
        const pages: Array<number> = [];

        if (this.data && this.data.totalPages > 1) {
            const maxPages = this.data.maxPageLinks ?? this.defaultMaxPageLinks;
            let firstPage = this.data.page - Math.floor(maxPages / 2);

            if (firstPage < 1) {
                firstPage = 1;
            }

            let lastPage = firstPage + maxPages - 1;

            if (lastPage > this.data.totalPages) {
                lastPage = this.data.totalPages;
            }

            for (let i = firstPage; i <= lastPage; i++) {
                pages.push(i);
            }
        }

        return pages;
    }
}
